import { readWishlist, removeWishlistItem, WISHLIST_KEY } from '@theme/wishlist-store';

/**
 * Renders the saved pieces inside the wishlist drawer and keeps the header heart count in sync.
 * Children: <template data-item> (one saved piece), [data-list], [data-empty], and any [data-wishlist-count] badge on the page.
 */
class WishlistList extends HTMLElement {
  connectedCallback() {
    this.template = this.querySelector('template[data-item]');
    this.list = this.querySelector('[data-list]');
    this.empty = this.querySelector('[data-empty]');
    this.onCommand = (event) => {
      if (event.command !== '--remove') return;
      const handle = event.source?.dataset.handle;
      if (handle) removeWishlistItem(handle);
    };
    this.onChange = () => this.render();
    this.onStorage = (event) => {
      if (event.key === WISHLIST_KEY) this.render();
    };
    this.addEventListener('command', this.onCommand);
    window.addEventListener('wishlist:change', this.onChange);
    window.addEventListener('storage', this.onStorage);
    this.render();
  }

  disconnectedCallback() {
    this.removeEventListener('command', this.onCommand);
    window.removeEventListener('wishlist:change', this.onChange);
    window.removeEventListener('storage', this.onStorage);
  }

  render() {
    const items = readWishlist();
    const counts = this.ownerDocument.querySelectorAll('[data-wishlist-count]');
    counts.forEach((badge) => {
      badge.textContent = String(items.length);
      badge.hidden = items.length === 0;
    });
    if (!this.template || !this.list) return;
    this.list.replaceChildren();
    items.forEach((item) => {
      const fragment = this.template.content.cloneNode(true);
      fragment.querySelectorAll('[data-link]').forEach((link) => link.setAttribute('href', item.url));
      const image = fragment.querySelector('[data-image]');
      if (image) {
        if (item.image) {
          image.setAttribute('src', item.image);
          image.setAttribute('alt', item.title || '');
        } else {
          image.remove();
        }
      }
      const title = fragment.querySelector('[data-title]');
      if (title) title.textContent = item.title || '';
      const price = fragment.querySelector('[data-price]');
      if (price) price.textContent = item.price || '';
      const remove = fragment.querySelector('[data-remove]');
      if (remove) {
        remove.dataset.handle = item.handle;
        remove.setAttribute('commandfor', this.id);
      }
      this.list.append(fragment);
    });
    if (this.empty) this.empty.hidden = items.length > 0;
  }
}

if (!customElements.get('s-wishlist-list')) customElements.define('s-wishlist-list', WishlistList);
